import { render, staticRenderFns } from "./DocxTemplate.vue?vue&type=template&id=2959a95e&scoped=true"
import script from "./DocxTemplate.vue?vue&type=script&lang=js"
export * from "./DocxTemplate.vue?vue&type=script&lang=js"
import style0 from "./DocxTemplate.vue?vue&type=style&index=0&id=2959a95e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959a95e",
  null
  
)

export default component.exports